import * as React from "react";
import {LandingPagePayload} from "../contenful/types";
import './styles/BottomSection.scss';
import {withRouter} from "react-router";
import {RouteComponentProps} from "react-router-dom";
import {BrandButton} from "../ui/buttons/buttons";


interface Props extends RouteComponentProps {
    landingpage: LandingPagePayload;
    loggedIn: boolean;
    classList?: string;
}


const BottomSection: React.FC<Props> = ({loggedIn, landingpage, history, classList}) => {
    return (
        <div className={`bottomSection ${classList}`}>
            {
                landingpage.bottomPromotion&& (
                    <div className={"section1"}>
                        <span className={"text"}>
                            {
                                landingpage.bottomPromotion
                            }
                        </span>
                    </div>
                )
            }
            <div className={"section2"}>
                <div className={"buttonWrap"}>
{/*                     {!loggedIn &&
                        <BrandButton  className={"btn btn-cta"} onClick={() => { history.push( "/playnow/register")} }>
                            {landingpage.buttonTitle}
                        </BrandButton>
                    } */}
                     {!loggedIn &&
                        <BrandButton  className={"btn btn-cta"} onClick={() => { history.push({search: new URLSearchParams({type: "registration", modal: "auth"}).toString()})} }>
                            {landingpage.buttonTitle}
                        </BrandButton>
                    }
                </div>
            </div>
        </div>
    )
}

export default withRouter<Props,any>(BottomSection);

